var map = {
	"./azul.css": [
		"8744",
		"chunk-74af6c4a"
	],
	"./verde.css": [
		"4d06",
		"chunk-748b7433"
	],
	"./vermelho.css": [
		"6ce51",
		"chunk-2056baa1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "c604";
module.exports = webpackAsyncContext;